import script from "./footerPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./footerPhone.vue?vue&type=script&setup=true&lang=js"

import "./footerPhone.vue?vue&type=style&index=0&id=1895f41c&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1895f41c"]])

export default __exports__